import logo from '../assets/images/logo512.png';

import './css/leftpanel.css'
import { Icon, Popup } from 'semantic-ui-react';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';


export default function LeftPanel({content}) {
    const [expanded, setExpanded] = useState(true);

    return (
        <>
        <div className='lp container'>
            <div className={`rectangleb leftpanel ${expanded? 'expanded' : 'collapsed'}`}>
                <div className={`lp vertical menu`}>
                    <div className={`lp pages`}>
                        <div style={{display: "flex", flexDirection: "row-reverse", margin: "1vh"}}>
                            <button onClick={() => setExpanded(!expanded)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: "white" }}>
                                <Icon link name={expanded ? 'angle double left' : 'sidebar'} size='large'/>
                            </button>
                        </div>
                        
                        <div className= {expanded ? "" : "logo-name-collapsed"}>
                            <h1 style={{ margin: "10px", fontSize: "large", color: "white"}}>SugarDB </h1>
                            <img src={logo} className='App-logo' style={{width:"100px", height:"100px", marginBottom:"1vh"}} alt="logo" />
                        </div>

                        <NavLink to="/database" className="lp item" activeClassName="active">
                            <div style={{ display: 'flex', justifyContent: 'space-between'}}>
                                <span className={ expanded ? "" : "menu-label-inactive"}>Database </span>
                                <Icon link name='database' size='large' />
                            </div>
                        </NavLink>
                        

                        <NavLink to="/editor" className="lp item" activeClassName="active">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                                <span className={ expanded ? "" : "menu-label-inactive"}>SNFG Editor </span> 
                                <Icon link name='edit outline' size='large' />
                            </div>
                        </NavLink>

                    </div>

                    <div className="lp extras" >
                        <h4>More options: </h4>
                        <div style={{ display:'flex', alignItems:'flex-end', flexDirection: expanded ? '' : 'column' }} >
                            <Popup inverted content='Suggest a new glycan' trigger={<NavLink style={{color:'white'}} to="/suggest"><Icon link name='idea' size='large' style={{cursor: 'pointer'}}/></NavLink>} />
                        </div>
                        
                    </div>
                    
                </div>
                
            </div>  
            
            <div className='leftpanelcontent'>
                {content}
            </div>
            
        </div>
        </>
    )
}